var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-layout flex"},[_c('app-aside'),_c('div',{staticClass:"app-content flex-1"},[_c('div',{staticClass:"app-body flex flex-column"},[_c('transition',{attrs:{"mode":"out-in","name":"fade-transform"}},[_c('keep-alive',[_c('router-view',{key:_vm.key})],1)],1),_c('app-footer')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }